import type { PanelMode } from '@/stores/companion-panel-store';

/**
 * Where the panel goes when it opens. Pushing keeps the page readable beside
 * the answer; once the page would shrink under 640px it is no longer usable,
 * so the panel covers it instead, and a phone-sized window gets the panel alone.
 */
export const COMPANION_PANEL_WIDTH = 440;
export const MIN_CONTENT_BESIDE_PANEL = 640;

export type { PanelMode };

export const decidePanelMode = (viewportWidth: number, sidebarWidth: number): PanelMode => {
  if (viewportWidth < MIN_CONTENT_BESIDE_PANEL) return 'fullscreen';
  return viewportWidth - sidebarWidth - COMPANION_PANEL_WIDTH >= MIN_CONTENT_BESIDE_PANEL
    ? 'push'
    : 'overlay';
};
